{
  "realm": "ansattporten",
  "url": "https://sso-hit.test.husbanken.no/auth",
  "clientId": "KoboPublicClient"
}
